import { Box } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type SpacingToken = 0 | 1 | 2 | 3 | 4 | 5 | '0' | '1' | '2' | '3' | '3-half' | '4' | '5';

export type ContainerProps = StructuredContentDocument<{
  spacing?: {
    top?: SpacingToken;
    bottom?: SpacingToken;
  };
  children: StructuredContentDocument;
}>;

const spacingMap: Record<SpacingToken, number | undefined> = {
  '0': undefined,
  '1': 1,
  '2': 2,
  '3': 3,
  '3-half': 3.5,
  '4': 4,
  '5': 5,
};

export const Container = ({ props }: ContainerProps) => {
  const spacingTop = spacingMap[props.spacing?.top ?? 0];
  const spacingBottom = spacingMap[props.spacing?.bottom ?? 0];
  return (
    <Box sx={{ marginTop: spacingTop, marginBottom: spacingBottom }}>
      <StructuredContentRenderer doc={props.children} />
    </Box>
  );
};
